import Http, {UrlFull} from '../Http';

export const authentication = () =>
  Http.post(UrlFull + 'api/login/authenticate', {
    Username: process.env.REACT_APP_USER,
    Password: process.env.REACT_APP_PASSWORD,
    app: process.env.REACT_APP_ID,
    version: '0.1',
    dispositivo: '',
  });
